import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Dialog } from "@mui/material";

import logoImg from "../../assets/imgs/crime/checkmark.png";
import mafiaImg from "../../assets/imgs/crime/mafia1.png";

import { toUSDFormat } from "../../utils/utils";
import useStyles from "./success.styles";

interface CrimeSuccessPopupProps {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  successXpPercent: number;
}

const CrimeSuccessPopup: React.FC<CrimeSuccessPopupProps> = ({
  openModal,
  setOpenModal,
  successXpPercent,
}) => {
  const { classes } = useStyles();

  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <Dialog open={openModal} onClose={handleClose} className={classes.body}>
      <Box className={classes.modalContent}>
        <Box className={classes.closeIconBody}>
          <Button onClick={handleClose}>
            <CloseIcon htmlColor="gray" />
          </Button>
        </Box>

        <Box className={classes.contentBody}>
          <Box component={"img"} src={logoImg} className={classes.logoImg} />
          <Box className={classes.titleText}>Success!</Box>
          <Box component={"img"} src={mafiaImg} className={classes.mafiaImg} />
          <Box className={classes.tryAgainText}>
            You just busted out the prisoner.
          </Box>
          <Box className={classes.remainTimeBox}>
            <Box className={classes.remainTime}>
              XP Earned: {toUSDFormat(successXpPercent, 2)}%
            </Box>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default CrimeSuccessPopup;
